import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import VduGatewayConfigurationFields from './VduGatewayConfigurationFields'

export const VduGatewayConfigurationCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props} />} redirect="list" >
      <Grid container spacing={8}>
        <VduGatewayConfigurationFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default VduGatewayConfigurationCreate
